import { render, staticRenderFns } from "./CertificadosForm.vue?vue&type=template&id=147bc05c&scoped=true&"
import script from "./CertificadosForm.vue?vue&type=script&lang=js&"
export * from "./CertificadosForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147bc05c",
  null
  
)

export default component.exports